var map = {
	"./logo-adt.png": "77ad",
	"./logo-adt@2x.png": "ef62",
	"./logo-allstate.png": "97df",
	"./logo-allstate@2x.png": "3643",
	"./logo-culturelle.png": "dcf5",
	"./logo-culturelle@2x.png": "2f1d",
	"./logo-dynacraft.png": "ea2f",
	"./logo-dynacraft@2x.png": "a195",
	"./logo-guess.png": "7c7c",
	"./logo-guess@2x.png": "f75b",
	"./logo-hermes.png": "ca03",
	"./logo-hermes@2x.png": "198c",
	"./logo-humanscale.png": "448a",
	"./logo-humanscale@2x.png": "fecb",
	"./logo-intuit.png": "87be",
	"./logo-intuit@2x.png": "9b70",
	"./logo-kate-spade.png": "1d96",
	"./logo-kate-spade@2x.png": "d09a",
	"./logo-kosher.com.png": "23c65",
	"./logo-kosher.com@2x.png": "7bfa",
	"./logo-lg.png": "8e0f",
	"./logo-lg@2x.png": "4f91",
	"./logo-logitech.png": "0e75",
	"./logo-logitech@2x.png": "c4ac",
	"./logo-nikon.png": "494a",
	"./logo-nikon@2x.png": "d7f0",
	"./logo-sap.png": "2bad",
	"./logo-sap@2x.png": "965e",
	"./logo-schick.png": "6d79",
	"./logo-schick@2x.png": "0379",
	"./logo-syfy.png": "47dd",
	"./logo-syfy@2x.png": "b802",
	"./logo-vonage.png": "0971",
	"./logo-vonage@2x.png": "3afd",
	"./logo-zeiss.png": "864b",
	"./logo-zeiss@2x.png": "a6de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5416";